import clsx from 'clsx'
import {useLocation} from 'react-router'
import SAISVG from '../../../../helpers/CommonFunction';
import { checkIsActive } from "../../../../helpers/RouterHelpers";

const SidebarMenuItemWithSub = ({children,to,title,icon,fontIcon,hasBullet}) => {
    const {pathname} = useLocation()
    const isActive = checkIsActive(pathname, to)

    return (
        <div className={clsx('menu-item mb-2', {'here show': isActive}, 'menu-accordion')}
            data-sai-menu-trigger='click' >
            <span className='menu-link'>
                {hasBullet && (
                <span className='menu-bullet'>
                    <span className='bullet bullet-dot'></span>
                </span>
                )}
                {icon && (
                <span className='menu-icon'>
                    <SAISVG path={icon} className='svg-icon-2' />
                </span>
                )}
                {fontIcon &&  (
                <i className={clsx('bi fs-3', fontIcon)}></i>
                )}
                <span className='menu-title'>{title}</span>
                <span className='menu-arrow'></span>
            </span>
            <div className={clsx('menu-sub menu-sub-accordion ms-15', {'menu-active-bg': isActive})}>
                {children}
            </div>
        </div>
    )
}

export default SidebarMenuItemWithSub;